import { LANGUAGES } from '../lib/i18n.js';
import { trackLanguageSelected } from '../lib/analytics.js';

// `langs` (optional) limits which language codes are shown, e.g. ['en','es'].
// Omitted = all LANGUAGES (home + men's-health pages keep the full set).
export default function LanguageSwitch({ value, onChange, langs }) {
  const list = langs ? LANGUAGES.filter((l) => langs.includes(l.code)) : LANGUAGES;
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Language">
      {list.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => {
            onChange(l.code);
            trackLanguageSelected(l.code);
          }}
          className={
            'btn-ghost ' +
            (value === l.code
              ? 'border-alfred-gold text-alfred-gold'
              : '')
          }
          aria-pressed={value === l.code}
          dir={l.dir}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
